import React from 'react';
import Modal from '@mui/material/Modal';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { CleaningRoom, ClientsCreate, ClientsEdit, UserCreate, UserEdit, CreateReservation, EditReservation, CreateProduct,
         EditProduct, CreateLevel, EditLevel, CreateCategory, EditCategory, CreateRoom, EditRoom, ProductList } from './forms/index';
import { useDispatch } from 'react-redux';
import { modalAction } from '../redux/reducers/Modal';
import { ValidDate } from './notifications/index';
import { UseScreen } from '../hooks/UseScreen.hook';


const SuccessModal = (props) => {

    const screenWidth = UseScreen();
    const [ style, setStyle ] = React.useState({});

    React.useEffect( () => {
        const modalStyle = () => {
            if( screenWidth <= 500 ){
                return {
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '90%',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    borderRadius: '.8rem',
                    p: 2,
                }
            }else{
                return {
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '60%',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    borderRadius: '.8rem',
                    p: 2,
                }
            }
        }

        setStyle(modalStyle());
    },[] )

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const dispatch = useDispatch();

    const viewDetails = () => {
        switch(props.view){
            case 'cleaningRoom': 
                return <CleaningRoom room={props.room} />;
            case 'newClient': 
                return <ClientsCreate />;
            case 'editClient': 
                return <ClientsEdit client={props.client} />;
            case 'newUser': 
                return <UserCreate />;
            case 'editUser': 
                return <UserEdit user={props.user} />;
            case 'newReservation': 
                return <CreateReservation />;
            case 'editReservation': 
                return <EditReservation />;
            case 'newProduct': 
                return <CreateProduct />;
            case 'editProduct': 
                return <EditProduct product={props.product} />;
            case 'newLevel': 
                return <CreateLevel />;
            case 'editLevel': 
                return <EditLevel level={props.level} />;
            case 'newCategory': 
                return <CreateCategory />;
            case 'editCategory': 
                return <EditCategory category={props.category} />;
            case 'newRoom': 
                return <CreateRoom />;
            case 'editRoom': 
                return <EditRoom room={props.room} />;
            case 'validDate':
                return <ValidDate />;
            case 'productList':
                return <ProductList />
            default: return null;
        }
    }

  return (
    <>
        <Modal
            open={true}
            onClose={ () => dispatch(modalAction()) }
        >
            <Grid container sx={style}>
                <Grid item xs={ 12 } textAlign='end'>
                    <IconButton align='end' style={{ backgroundColor: '#EEE', width: '1rem', height: '1rem' }} onClick={ () => dispatch(modalAction()) }>
                        <CloseIcon style={{ color: '#000', width: '.8rem' }} align='end' />
                    </IconButton>
                </Grid>
                {
                    viewDetails()
                }
            </Grid>
        </Modal>
    </>
  )
}

export default SuccessModal